/**
 * Check if first Int64 is greater than second
 *
 * @param {import('./Int64Type.js').BrandedInt64} a - First value
 * @param {import('./Int64Type.js').BrandedInt64} b - Second value
 * @returns {boolean} True if a > b
 */
export function greaterThan(a, b) {
	return a > b;
}
